import { IconActionArrowRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';

export interface IRightArrowProps {
  onClick: () => void;
}

export const RightArrow: React.FC<IRightArrowProps> = ({ onClick }) => {
  return (
    <div className={style['item']} onClick={onClick}>
      <IconActionArrowRight12 color="gray_icons_100" />
    </div>
  );
};
